import React from 'react';

const PricingEnrollment = () => (
  <section className="pricing-enrollment">
    <h2>Pricing & Enrollment</h2>
    <div className="pricing-details">
      <h3>$399</h3>
      <ul>
        <li>6 months access</li>
        <li>All labs & projects</li>
        <li>Mentorship & support</li>
        <li>Certification prep</li>
      </ul>
      <p>7-day money-back guarantee</p>
      <button className="enroll-btn">Start Learning Today</button>
    </div>
  </section>
);

export default PricingEnrollment; 